export const REDUCER_KEY = 'reporting';

// auth types
export const AUTH_ALLOWED = 'allowed';
export const AUTH_ADMIN = 'admin';
export const AUTH_DEMO = 'demo';
